import {useEffect, useId, useState} from "react";
import {CheckIcon, SearchIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {GradeToString} from "../students/list";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {
    CurrencyFormat,
    NumberToPersianLetters,
    StringDigitsConvertToPersian,
    ToxicDigitsFixToEnglish
} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {TimePicker} from "../../../components/timepicker/timepicker";
import {DateFixToGoLayout, TimeFixToGoLayout} from "../../../components/techaran/date-convert";

interface studentsInterface {
    id: number, // studentId
    name: string,
    class: string,
    grade: number,
    isSelected: boolean,
}

export const AdminFinanceGroupPaymentModal = (props: { active: boolean, closeHandler: any }) => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as studentsInterface[]);
    const fetchList = () => {
        setLoaded(false);
        PostJSON(
            Apis.server + '/core/admins/finance/group/payment/get-students',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: {
                    id: number, // studentId
                    name: string,
                    class: string,
                    grade: number,
                }[] | null
            }) => {
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                let lst = [] as studentsInterface[];
                if (d.list !== null) {
                    d.list.forEach((s, i) => {
                        lst.push({
                            id: s.id,
                            name: s.name,
                            grade: s.grade,
                            class: s.class,
                            isSelected: true,
                        });
                    });
                }
                setList([...lst]);
            },
            () => {
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add('body-no-scroll');
            setLevel('select');
            fetchList();
            let todayIso = new Date().toISOString().split('T')[0];
            setTime({
                time: [0, 0,0],
                date: todayIso,
            });
            setPrice('');
            setPayMethod('cash');
            setErr({
                price: false,
            });
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active]);
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (!loaded || level !== 'select')
            return;
        const filter = search.toUpperCase().trim();
        const lst = document.querySelector('.reports--select-employee-buttons2');
        const btns = (lst as HTMLDivElement).getElementsByTagName('button');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('span')[0];
            if(typeof b === 'undefined')
                continue;
            const v = b.innerHTML.toUpperCase();
            const noSpace = v.replaceAll(' ','');
            if (v.indexOf(filter) > -1 || noSpace.indexOf(filter.replaceAll(' ','')) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    const [level, setLevel] = useState('select' as 'select' | 'fill');
    const [price, setPrice] = useState('0');
    const [time, setTime] = useState({
        time: [0, 0, 0],
        date: '2024-01-01',
    });
    const [payMethod, setPayMethod] = useState('cash' as "online" | "cash" | "old");
    const [err, setErr] = useState({
        price: false,
    });
    const ids = {
        price: useId(),
    };
    const saveChanges = () => {
        const lst = [...list];
        const finalList = [] as number[];
        lst.forEach(e=>{
            if(e.isSelected)
                finalList.push(e.id);
        });
        const _price = price;
        const paidAt = {...time};
        const method = payMethod;
        if(_price === ''){
            setErr({
                price: true,
            });
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/finance/group/payment/add',
            {
                data:JSON.stringify(finalList),
                price:_price,
                paidAt:TimeFixToGoLayout(`${paidAt.date} ${paidAt.time[0]}:${paidAt.time[1]}:${paidAt.time[2]}`),
                payMethod:method,
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
                count:number,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                   `پرداخت برای ${StringDigitsConvertToPersian(CurrencyFormat(d.count))} دانش‌آموز ثبت شد.`,
                    'باشه',
                    5000,
                );
                props.closeHandler();
            },
            ()=>{
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const isAllChecked = () => {
        const lst = [...list];
        let isAllChecked = true;
        lst.forEach(e=>{
            if(!e.isSelected)
                isAllChecked = false;
        });
        return isAllChecked;
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '') + (level === 'fill' ? ' web-modal-big':'')} style={loaded ? {top: 20} : {}}>
                <div className="web-modal-header">
                    <div><b>ثبت پرداخت گروهی</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="reports--select-employee">
                        {
                            loaded ?
                                (
                                    level === 'fill' ?
                                        <>
                                            <div className="container">
                                                <div className="add-student">
                                                    <div className="row no-gutters align-items-end">
                                                        <div className="col-lg-6">
                                                            <label htmlFor={ids.price}>هزینه پرداختی:</label>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                className={"form-control" + (err.price ? ' is-invalid' : '')}
                                                                value={price}
                                                                onChange={e => {
                                                                    const t = e.currentTarget.value;
                                                                    setPrice(ToxicDigitsFixToEnglish(t));
                                                                    setErr({
                                                                        price: false,
                                                                    });
                                                                }}
                                                            />
                                                            {
                                                                price !== '' ?
                                                                    <span style={{
                                                                        display: 'block',
                                                                        margin: '5px 0 0 0',
                                                                        fontWeight: 400,
                                                                        color: '#0a53be'
                                                                    }}>
                                       {NumberToPersianLetters(parseInt(price)) + " تومان"}
                                   </span> : null
                                                            }
                                                            <div
                                                                className={"invalid-feedback " + (err.price ? 'd-block' : 'd-none')}>
                                                                لطفا مبلغ را بصورت صحیح وارد نمایید.
                                                            </div>
                                                            <div style={{height: 20}}/>
                                                            <label>تاریخ پرداخت:</label>
                                                            <TimePicker
                                                                lang={'fa'}
                                                                hour={time.time[0]}
                                                                minute={time.time[1]}
                                                                setState={(h: number, m: number) => setTime(v => {
                                                                    let x = {...v};
                                                                    x.time[0] = h;
                                                                    x.time[1] = m;
                                                                    return x;
                                                                })}
                                                                title={''}
                                                                locked={false}
                                                                onSave={() => {
                                                                }}
                                                                date={time.date}  // gregorian
                                                                setDate={(d: string) => setTime(v => {
                                                                    let x = {...v};
                                                                    x.date = d.split(" ")[0];
                                                                    return x;
                                                                })}
                                                                hasDate={true}
                                                            />
                                                            <div style={{height: 20}}/>
                                                            <label>نحوه پرداخت:</label>
                                                            {/*<button*/}
                                                            {/*    className={"techaran-radio-box" + (payMethod === 'online' ? ' active' : '')}*/}
                                                            {/*    onClick={() => setPayMethod('online')}>*/}
                                                            {/*    <div><i/></div>*/}
                                                            {/*    <span>آنلاین</span>*/}
                                                            {/*</button>*/}
                                                            <button
                                                                className={"techaran-radio-box" + (payMethod === 'cash' ? ' active' : '')}
                                                                onClick={() => setPayMethod('cash')}>
                                                                <div><i/></div>
                                                                <span>نقدی</span>
                                                            </button>
                                                            {/*<button*/}
                                                            {/*    className={"techaran-radio-box" + (payMethod === 'old' ? ' active' : '')}*/}
                                                            {/*    onClick={() => setPayMethod('old')}>*/}
                                                            {/*    <div><i/></div>*/}
                                                            {/*    <span>سامانه قدیم</span>*/}
                                                            {/*</button>*/}
                                                            <div style={{height: 120}}/>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div
                                                                className="d-flex justify-content-end align-items-center"
                                                                style={{gap: 20, marginTop: 0}}>
                                                                <button className="cancel-button"
                                                                        onClick={props.closeHandler}>
                                                                    <b>انصراف</b>
                                                                </button>
                                                                <button className="btn-pay" onClick={saveChanges}>
                                                                    <b>ذخیره تغییرات</b>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </> :
                                        <>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label>انتخاب دانش‌آموزان</label>
                                                <button className="btn-pay" onClick={() => {
                                                    const lst = [...list];
                                                    if (lst.findIndex((e) => e.isSelected) < 0) {
                                                        ShowSnackbar('لطفا حداقل یک دانش‌آموز را انتخاب کنید.', 'باشه', 5000);
                                                        return;
                                                    }
                                                    setLevel('fill');
                                                }}>
                                                    <b>مرحله بعدی</b>
                                                </button>
                                            </div>
                                            <div className="pick-device-search">
                                                <button><SearchIcon/></button>
                                                <input type="text"
                                                       value={search}
                                                       onChange={e => setSearch(e.currentTarget.value)}
                                                       onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                                       onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                                       className="f-roboto"
                                                       placeholder={"جستجو براساس نام یا کلاس..."}
                                                />
                                            </div>
                                            {
                                                search.trim() === '' && list.length > 0 ?
                                                    <>
                                                        <hr/>
                                                        <button className={"techaran-checkbox" + (isAllChecked() ? ' active':'')} onClick={()=>{
                                                            const isChecked = isAllChecked();
                                                            if(isChecked)
                                                                setList(v=>{
                                                                    let x = [...v];
                                                                    x.forEach(r=> {
                                                                        r.isSelected = false;
                                                                    });
                                                                    return x;
                                                                });
                                                            else
                                                                setList(v=>{
                                                                    let x = [...v];
                                                                    x.forEach(r=> {
                                                                        r.isSelected = true;
                                                                    });
                                                                    return x;
                                                                });
                                                        }}>
                                                            <i><CheckIcon/></i>
                                                            <span>انتخاب همه</span>
                                                        </button>
                                                        <hr/>
                                                    </> : null
                                            }
                                            <div className="reports--select-employee-buttons2">
                                                {
                                                    list.map((e, i) =>
                                                            <button key={"KJds83jns8932d" + i}
                                                                    className={"techaran-checkbox" + (e.isSelected ? ' active' : '')}
                                                                    onClick={() => setList(v => {
                                                                        let x = [...v];
                                                                        const id = x.findIndex(r => r.id === e.id);
                                                                        x[id].isSelected = !x[id].isSelected;
                                                                        return x;
                                                                    })}>
                                                                <i>
                                                                    <CheckIcon/>
                                                                </i>
                                                                <span>
                                            {e.name.replaceAll('ي','ی')}
                                                                    <em>{(e.class === '' ? 'بدون کلاس - ' : `${e.class} - `) + GradeToString(e.grade)}</em>
                                        </span>
                                                            </button>
                                                    )
                                                }
                                            </div>
                                        </>
                                ) :
                                <div className="d-flex justify-content-center align-items-center"
                                     style={{padding: '70px 0'}}>
                                    <div className="spinner-border" style={{color: '#2b2b2b'}}/>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};